import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ICardholderFormMeta {
  // Card Data
  cardNumber: FormInputMeta;
  cardSequenceNumber: FormInputMeta;
  iccApplication: FormInputMeta;
  cardStatus: FormInputMeta;
  startDate: FormInputMeta;
  expiryDate: FormInputMeta;
  // Bin Data
  issuerBank: FormInputMeta;
  bin: FormInputMeta;
  serviceRestrictionCode: FormInputMeta;
  binType: FormInputMeta;
  productType: FormInputMeta;
  // Customer
  customer: FormInputMeta;
  solvabilityLevel: FormInputMeta;
  customerStatus: FormInputMeta;
  vipLevel: FormInputMeta;
  // Account
  accountNumber: FormInputMeta;
  currency: FormInputMeta;
  accountStatus: FormInputMeta;
  balance: FormInputMeta;


  schema: any;
}

const CardholderFormMeta = {} as ICardholderFormMeta;
  // Card Data
  CardholderFormMeta.cardNumber = {
    name: 'cardNumber',
    type: 'text',
    label: 'N° carte',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  },
  CardholderFormMeta.cardSequenceNumber = {
    name: 'cardSequenceNumber',
    type: 'text',
    label: 'N° sequence carte',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  },
  CardholderFormMeta.iccApplication = {
    name: 'iccApplication',
    type: 'text',
    label: 'ICC Application',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  },
  CardholderFormMeta.cardStatus = {
    name: 'cardStatus',
    type: 'text',
    label: 'Statut carte',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  },
  CardholderFormMeta.startDate = {
    name: 'startDate',
    type: 'text',
    label: 'Date debut',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  },
  CardholderFormMeta.expiryDate = {
    name: 'expiryDate',
    type: 'text',
    label: 'Date fin',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }

  // Bin Data
  CardholderFormMeta.issuerBank = {
    name: 'issuerBank',
    type: 'text',
    label: 'Banque source',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  CardholderFormMeta.bin = {
    name: 'bin',
    type: 'text',
    label: 'BIN',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  CardholderFormMeta.serviceRestrictionCode = {
    name: 'serviceRestrictionCode',
    type: 'text',
    label: 'Code restriction service',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  CardholderFormMeta.binType = {
    name: 'binType',
    type: 'text',
    label: 'Type BIN',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  CardholderFormMeta.productType = {
    name: 'productType',
    type: 'text',
    label: 'Type produit',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }

  // Customer

  CardholderFormMeta.customer = {
    name: 'customer',
    type: 'text',
    label: 'Client',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  CardholderFormMeta.solvabilityLevel = {
    name: 'solvabilityLevel',
    type: 'text',
    label: 'Niveau solvabilite',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  CardholderFormMeta.customerStatus = {
    name: 'customerStatus',
    type: 'text',
    label: 'Statut client',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  CardholderFormMeta.vipLevel = {
    name: 'vipLevel',
    type: 'text',
    label: 'Niveau VIP',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }

  // Account

  CardholderFormMeta.accountNumber = {
    name: 'accountNumber',
    type: 'text',
    label: 'N° compte',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  CardholderFormMeta.currency = {
    name: 'currency',
    type: 'text',
    label: 'Devis',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  CardholderFormMeta.accountStatus = {
    name: 'accountStatus',
    type: 'text',
    label: 'Statut compte',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }
  CardholderFormMeta.balance = {
    name: 'balance',
    type: 'text',
    label: 'Balance',
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
  }


CardholderFormMeta.schema = yup.object().shape(getValidationSchema(CardholderFormMeta));

export default CardholderFormMeta;